import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { UtilsService } from 'src/app/shared/services/utils.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
    selector: 'molla-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})

export class HeaderComponent implements OnInit {

	@Input() containerClass = "container";

	wishCount = 0;

	constructor(public activeRoute: ActivatedRoute, public utilsService: UtilsService, public modalService: ModalService,
		public apiService: ApiService) {			
	}

	async ngOnInit(): Promise<void> {}

	showLoginModal(event: Event): void {
		event.preventDefault();
		this.modalService.showLoginModal();
	}

	async shareCurrentPage(event: Event): Promise<void> {
		event.preventDefault();

		if (typeof window === 'undefined') {
			return;
		}

		const shareData = {
			title: document.title || this.apiService.company_name || 'Share',
			url: window.location.href
		};

		const navigatorRef = navigator as any;

		if (navigatorRef.share) {
			try {
				await navigatorRef.share(shareData);
				return;
			} catch (error: any) {
				if (error?.name === 'AbortError') {
					return;
				}
			}
		}

		await this.copyToClipboard(shareData.url);
		this.apiService.popupMsg(this.apiService.company_name, 'Link copied', 'info');
	}

	private async copyToClipboard(value: string): Promise<void> {
		const navigatorRef = navigator as any;

		if (navigatorRef.clipboard?.writeText) {
			await navigatorRef.clipboard.writeText(value);
			return;
		}

		const textArea = document.createElement('textarea');
		textArea.value = value;
		textArea.setAttribute('readonly', '');
		textArea.style.position = 'fixed';
		textArea.style.left = '-9999px';
		document.body.appendChild(textArea);
		textArea.select();
		document.execCommand('copy');
		document.body.removeChild(textArea);
	}
}
